import { z } from "zod";


export const PRESET_AGENT_ENUM_VALUES = [
  "SALES_AGENT",
  "SUPPORT_AGENT",
  "TASKS_AGENT",
  "COMPUTER_USE_AGENT",
  "ANALYST_AGENT",
  "COMMAND_AGENT",
  "BROWSER_AGENT",
] as const;

export type PresetAgentEnumValue = (typeof PRESET_AGENT_ENUM_VALUES)[number];

export const PRESET_AGENT_LABELS: Record<PresetAgentEnumValue, string> = {
  SALES_AGENT: "Sales Agent",
  SUPPORT_AGENT: "Support Agent",
  TASKS_AGENT: "Task Agent",
  COMPUTER_USE_AGENT: "Computer Use Agent",
  ANALYST_AGENT: "Call Analyst",
  COMMAND_AGENT: "Command Agent",
  BROWSER_AGENT: "Browser Agent",
};

export const presetAgentNameSchema = z.enum(PRESET_AGENT_ENUM_VALUES);

export function isPresetAgentNameValue(
  value: string | null | undefined
): value is PresetAgentEnumValue {
  return (
    typeof value === "string" &&
    (PRESET_AGENT_ENUM_VALUES as readonly string[]).includes(value)
  );
}


export function coercePresetAgentNameToEnum(
  saved: string | null | undefined
): PresetAgentEnumValue {
  if (isPresetAgentNameValue(saved)) return saved;
  if (!saved) return "SALES_AGENT";
  const legacyDisplay: Record<string, PresetAgentEnumValue> = {
    "Sales Agent": "SALES_AGENT",
    "Support Agent": "SUPPORT_AGENT",
    "Task Agent": "TASKS_AGENT",
    "Browser Use Agent": "BROWSER_AGENT",
  };
  return legacyDisplay[saved] ?? "SALES_AGENT";
}


export function labelForPresetAgentName(saved: string | null | undefined): string {
  if (isPresetAgentNameValue(saved)) return PRESET_AGENT_LABELS[saved];
  return saved ?? "";
}


function toTitleCaseWords(s: string): string {
  return s
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}


export function displayPresetAgentName(saved: string | null | undefined): string {
  return toTitleCaseWords(labelForPresetAgentName(saved));
}
